import { onParseResponse } from "@/utils/axiosUtil";

const API_ENDPOINTS = {
  resumes: "/api/resumes",
};

export const getResumesAPI = async ({
  page = 1,
  limit = 10,
  searchBy = "",
}) => {
  return await onParseResponse({
    method: "get",
    url: API_ENDPOINTS.resumes,
    params: {
      page,
      limit,
      searchBy,
    },
  });
};

export const getResumeByIdAPI = async (id) => {
  return await onParseResponse({
    method: "get",
    url: `${API_ENDPOINTS.resumes}/${id}`,
  });
};

export const createResumeAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes,
    data,
  });
};

export const updateResumeAPI = async (id, data) => {
  return await onParseResponse({
    method: "patch",
    url: `${API_ENDPOINTS.resumes}/${id}`,
    data,
  });
};

export const deleteResumeAPI = async (id) => {
  return await onParseResponse({
    method: "delete",
    url: `${API_ENDPOINTS.resumes}/${id}`,
  });
};

export const uploadResumeAPI = async (file) => {
  console.log("file in API:", {
    name: file?.name,
    type: file?.type,
    size: file?.size,
    lastModified: file?.lastModified,
  });

  const formData = new FormData();
  formData.append("resumeFile", file);

  const response = await onParseResponse({
    method: "post",
    url: `/api/resumes/upload-resume`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    transformRequest: [
      (data) => {
        console.log("Transform request - data type:", typeof data);
        return data;
      },
    ],
  });

  return response;
};

export const updateResumeStatusToActiveAPI = async (id) => {
  return await onParseResponse({
    method: "patch",
    url: `/api/resumes/update-status/${id}`,
  });
};

export const updateResumeNameAPI = async (id, data) => {
  return await onParseResponse({
    method: "patch",
    url: `/api/resumes/update-name/${id}`,
    data,
  });
};

export const applyResumeTemplateAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + "/templates",
    data,
  });
};

export const getResumeTemplateAPI = async () => {
  return await onParseResponse({
    method: "get",
    url: API_ENDPOINTS.resumes + "/templates",
  });
};

export const previewResumeAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + `/preview-resume`,
    data,
  });
};

export const previewResumeWithTemplateAPI = async (templateSlug, data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + `/preview-resume/${templateSlug}`,
    data,
    responseType: "text",
  });
};

export const generateResumeAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + "/generate-resume",
    data,
  });
};

export const refineResumeAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + "/refine-objective",
    data,
  });
};

export const resumeImproveSuggestionAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + "/improve-resume-suggestion",
    data,
  });
};

export const modifyResumeAPI = async (data) => {
  return await onParseResponse({
    method: "post",
    url: API_ENDPOINTS.resumes + "/modify-resume",
    data,
  });
};
